import React from "react";
import { connect } from "react-redux";
import { Column } from 'primereact/column';
import { Page } from "../../../components/page/Page";
import { HistoryCargoShipmentList } from "./HistoryCargoShipmentList";
import { actions } from '../historyCargoShipment.actions'
import { AppService, COMPANY_CHANGE_EVENT_NAME, BUSINESS_UNIT_CHANGE_EVENT_NAME } from "../../../services/app.service";
import { actions as appActions } from '../../../store/app';
import * as menuActions from '../../../store/menu/menu.actions';
import * as utils from '../../../utils'
import { Filter } from "../components/Filter";
import moment from "moment";

const mapStateToProps = state => {
    const currentMenu = state.menuState.currentRecord;
    const userConfigurations = state.appState.userConfigurations;
    let isFavorite = utils.isFavorite(currentMenu, userConfigurations); 
    return {
        columns: state.crudHistoryCargoShipmentState.columns,
        records: state.crudHistoryCargoShipmentState.records,
        first: state.crudHistoryCargoShipmentState.index,
        rows: state.crudHistoryCargoShipmentState.max,
        totalRecords: state.crudHistoryCargoShipmentState.count,
        sortField: state.crudHistoryCargoShipmentState.sortField,
        order: state.crudHistoryCargoShipmentState.sortOrder,
        menuItems: state.menuState.items,
        filterFields: state.crudHistoryCargoShipmentState.filterFields,
        currentMenu,
        isFavorite,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        paginate: paginationParams => dispatch(actions.paginate(paginationParams)),
        sortOrder: sortParams => dispatch(actions.sortOrder(sortParams)),
        applyFilter: filterParams => {
            dispatch(actions.applyFilter(filterParams))
        }, 
        load: (filterParams) => {
            dispatch(actions.loadParams(filterParams)) 
        },       
        userLastAccess: (oidMenu) => dispatch(appActions.userLastAccess(oidMenu)),
        setCurrentMenu: (menuPath) => dispatch(menuActions.setCurrentRecord(menuPath)),
        toggleFavorite: (isFavorite, oidMenu) => {
            dispatch(appActions.toggleFavorite(isFavorite, oidMenu))
        },
        initialDateChangeHandler: (e) => dispatch(actions.initialDateChangeHandler(e.value)),
        finalDateChangeHandler: (e) => dispatch(actions.finalDateChangeHandler(e.value)),
        downloadReportHandler: () => dispatch(actions.downloadReport()),
    }
}

class HistoryCargoShipmentListPageContainer extends React.Component {

 

    componentDidMount() { 
        AppService.on(COMPANY_CHANGE_EVENT_NAME, this);
        AppService.on(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
        this.applyFilterHandler();
    }
    componentWillUnmount() {
        AppService.off(COMPANY_CHANGE_EVENT_NAME, this);
        AppService.off(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
    }

    onReceiveAppNotifications = (eventName, params) => {
        if (eventName === COMPANY_CHANGE_EVENT_NAME || eventName === BUSINESS_UNIT_CHANGE_EVENT_NAME) {
            this.applyFilterHandler();
        }
    }

    onPage = (e) => {
        this.props.paginate({
            max: e.rows,
            index: e.first
        })
    }
    onSort = (e) => {
        // console.log('sorting', e);
        this.props.sortOrder({
            sortOrder: e.sortOrder,
            sortField: e.sortField
        })


    }
    onFilter = (e) => {
        // console.log(e);
        const filters = [];
        const keys = Object.keys(e.filters) || [];
        keys.forEach(key => {
            if (e.filters.oid) {
                filters.push({
                    campo: key,
                    valor: parseInt(e.filters[key].value),
                    tipoFiltro: 'IGUAL_A'
                })
            } else {
                filters.push({
                    campo: key,
                    valor: e.filters[key].value,
                    tipoFiltro: 'CONTEM'
                })
            }
        })
        // console.log(filters);
        // filters.push({
        //     campo: "active",
        //     valor: false,
        //     tipoFiltro: "IGUAL_A",
        // })
        this.props.applyFilter(filters)
    }

    onFavorite = (e) => {
        if (this.props.currentMenu) {
            const oidMenu = this.props.currentMenu.oid
            const isFavorite = this.props.isFavorite;
            this.props.toggleFavorite(isFavorite, oidMenu)
        }
    }
    initialDateChangeHandler = (e) => {
        this.props.initialDateChangeHandler(e)
    }
    finalDateChangeHandler = (e) => {
        this.props.finalDateChangeHandler(e)
    }

    applyFilterHandler = () => {
        const normalizeDate = (date) => {
            return date && typeof date === "object" ? date : null;
          };
        const initialDateFilter = normalizeDate(this.props.filterFields.initialDate);
        const finalDateFilter = normalizeDate(this.props.filterFields.finalDate);        
        
        const filters = [];
        if (initialDateFilter && finalDateFilter) {
            filters.push({
              campo: "createdAt",
              campoComplementar: "createdAt",
              valor: initialDateFilter,
              valorComplementar: finalDateFilter,
              tipoFiltro: "ENTRE",
            });
        } 
        // filters.push({
        //     campo: "active",
        //     valor: false,
        //     tipoFiltro: "IGUAL_A",
        // })
        this.props.load(filters)
    }

    downloadReport = () => {
        this.props.downloadReportHandler()
    }   

    render() {
        const isFavorite = this.props.isFavorite;

        const header = (
            <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h1>Histórico de Embarques</h1>

                    <i className={`pi pi-star lxFavoriteStar ${isFavorite ? 'lxFavorite' : ''}`}
                        title={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'} onClick={this.onFavorite}></i>
                </div>
                <hr className="lxSplitter" ></hr>
                
                    {/* <Toolbar onNew={this.newHandler} newButtonStyle='highlighted'>
                    </Toolbar > */}
                    <Filter 
                        filterFields={this.props.filterFields}
                        initialDateChangeHandler={this.props.initialDateChangeHandler}
                        finalDateChangeHandler={this.props.finalDateChangeHandler}
                        applyFilter={this.applyFilterHandler}
                        downloadReport={this.downloadReport}
                    />

                
            </div>
        );

        const oidTemplate = (rowData, column) => {
            return (
                // <div style={{ textAlign: "center" }} className="id-link"><Link to={`${routes.PATH_HISTORY_CARGO_SHIPMENT_CANCELED}/${rowData.oid}`}>{rowData.oid}</Link></div>
                <div style={{ textAlign: "center" }} className="id-link">{rowData.oid}</div>
            )
        }

        const statusTemplate = (rowData, column) => {
            let status = "Em Trânsito"
            if (rowData.status === "NEW") {
                status = "Novo"
            } else if (rowData.status === "REJECTED") {
                status = "Rejeitado"
            } else if (rowData.status === "CANCELED") {
                status = "Cancelado"
            } else if (rowData.status === "EM_TRANSITO") {
                status = "Em Trânsito"
            }
            return (
                <div style={{ textAlign: "center" }} >{status}</div>
            )
        }

        const formatDateTemplate = (rowData, column) => {
            const date = new Date(rowData.createdAt);
            const formattedDate = moment(date).format('DD/MM/YYYY HH:mm');
            return (
                <div style={{ textAlign: "center" }} >{formattedDate}</div>
            )
        }

        const activeTemplate = (rowData, column) => {
            if (rowData.active !== "Cancelado") {
                return <div style={{ color: 'green', display: 'flex', justifyContent: 'center' }}><span className="pi pi-check-circle" style={{ 'fontSize': '1.8rem' }} title="Embarque ativo"/> </div>;
            } else {
                return <div style={{ color: 'red', display: 'flex', justifyContent: 'center' }}><span className="pi pi-times-circle" style={{ 'fontSize': '1.8rem' }} title="Embarque cancelado"/> </div>;
            }
        }    

       

        const columns = this.props.columns.map(col => {
            if (col.field === 'oid') {
                return (<Column {...col} key={col.field} body={oidTemplate} style={{ width: '10%' }} />);
            } else if (col.field === 'status') {
                return (<Column {...col} key={col.field} body={statusTemplate} style={{ width: '10%' }} />);
            } else if (col.field === 'createdAt') {
                return (<Column {...col} key={col.field} body={formatDateTemplate} style={{ width: '10%' }} />);
            } else if (col.field === 'inactiveAt') {
                return (<Column {...col} key={col.field} body={formatDateTemplate} style={{ width: '10%' }} />);
            } else if (col.field === 'active') {
                return (<Column {...col} key={col.field} body={activeTemplate} style={{ width: '10%' }} />);
            }

            return (<Column  style={{ textAlign: "center" }} {...col} key={col.field} />)
        })

        const content = <HistoryCargoShipmentList  
            {...this.props} 
            onFilter={this.onFilter} 
            onPage={this.onPage} 
            onSort={this.onSort} 
            columns={columns} 
        />;
        
        return <Page header={header} content={content} />;

    }
}
export default connect(mapStateToProps, mapDispatchToProps)(HistoryCargoShipmentListPageContainer);
